<template>
  <div/>
</template>

<script>
export default {
  props: {
    data: Array
  },
  mounted() {
    this.$store.commit("setNotifications", this.data);
  }
};
</script>
